import { ICidReplaceForm, CidModel } from '../models/cid.model';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { WebappsCidApi } from './webapps-cid.api';

export const CidsApi = {
	create: async (currentCid: id, body: ICidReplaceForm, options?: IRequestOptions): Promise<CidModel> => {
		return WebappsCidApi.replaceCid(currentCid, body, options).then(() => new CidModel());
	},

	edit: (): Promise<null> => {
		throw new Error('Not implemented');
	},

	list: async (): Promise<CidModel[]> => {
		throw new Error('Not implemented');
	},

	get: async (): Promise<CidModel> => {
		throw new Error('Not implemented');
	},

	delete: async () => {
		throw new Error('Not implemented');
	},
};
